import { Card, CardContent, Divider, Skeleton, Stack, SxProps, Typography } from "@mui/material";
import React from "react";
import { useBreakpoints } from "src/hooks";

type StatisticItem =
  | { title: string; value: number | string; render?: never; renderSkeleton?: React.ReactNode; sx?: SxProps }
  | { title: string; render: React.ReactNode; value?: never; renderSkeleton?: React.ReactNode; sx?: SxProps };

interface IProps {
  isLoading: boolean;
  data: StatisticItem[];
  sx?: SxProps;
}

const StatisticsCard = (props: IProps) => {
  const { isMdUp } = useBreakpoints();

  return (
    <Card sx={props.sx}>
      <CardContent sx={{ p: 0.5, overflowX: "auto" }}>
        <Stack direction="row" divider={<Divider flexItem orientation="vertical" />} spacing={isMdUp ? 1 : 0.5}>
          {props.data.map((item) => (
            <Stack key={item.title} sx={{ justifyContent: "space-between", minWidth: 120, ...item.sx }}>
              <Typography
                variant="caption"
                sx={{ textTransform: "uppercase", whiteSpace: "pre-line", lineHeight: "16px" }}
              >
                {item.title}
              </Typography>
              <Stack direction="row" spacing={0.5} sx={{ alignItems: "end" }}>
                {props.isLoading ? (
                  (item.renderSkeleton ?? <Skeleton variant="rectangular" height={55} width={55} />)
                ) : item.value != null ? (
                  <Typography variant={isMdUp ? "h1" : "h3"}>{item.value}</Typography>
                ) : (
                  item.render
                )}
              </Stack>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export { StatisticsCard };
export type { StatisticItem };
